

// "Fri May 31 2024 00:00:00 GMT+0530 (India Standard Time)" ===>  "31/05/2024"
export function CovertString_TO_DateFormat(currdate) {
    const dateString = currdate;
    const date = new Date(dateString);
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    return formattedDate;
}

export const API_BASE_URL = "https://partywitty.com";